import api from './abstract';

const settingsApi = {
    getSettings() {
        return api.get('/settings');
    }
};

export default settingsApi;